// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2bREP","sendOtp":"AuthorizeToLogin_sendOtp__10Ntz"};